import { useMemo } from 'react';
import { useAppStore } from '../../../store/appStore';

export const useSharedState = () => {
  const state = useAppStore();
  const updateVideoState = useAppStore(state => state.updateVideoState);
  
  // 使用memoized selectors减少不必要的重渲染
  const memoizedState = useMemo(() => ({
    currentTime: state.videoState.currentTime,
    isPlaying: state.videoState.isPlaying,
    activeRobotId: state.selection.activeRobotId,
    activeEventId: state.selection.activeEventId,
    videoUrl: state.videoUrl,
    timeframe: state.timeframe,
    processingUpdate: state.metadata.processingUpdate,
    updateVideoState
  }), [
    state.videoState.currentTime,
    state.videoState.isPlaying,
    state.selection.activeRobotId,
    state.selection.activeEventId,
    state.videoUrl,
    state.timeframe,
    state.metadata.processingUpdate,
    updateVideoState
  ]);
  
  return memoizedState;
}; 